import { useCallback } from 'react';
import { useRootStore } from 'store';

export const useFormPermissions = (data: any) => {
  const { appStore } = useRootStore();

  function calcUserCanEdit() {
    const canEdit = appStore.isPlatformOwner;

    const canEditReasoning = '';
    return { canEdit, canEditReasoning };
  }
  const { canEdit, canEditReasoning } = calcUserCanEdit();

  const calcUserCanView = useCallback(() => {
    let canView = false;
    let canViewReasoning = 'init false';

    if (appStore.isPlatformOwner) {
      canView = true;
      canViewReasoning = 'OK';
    } else if (appStore.isCollector) {
      canView = data?.collectorId === appStore.associatedId; // Same Collector
      canViewReasoning = 'Δεν έχετε δικαίωμα προβολής αυτής της εγγραφής.';
    } else {
      canView = false;
      canViewReasoning = 'Δεν έχετε δικαίωμα προβολής αυτής της εγγραφής.';
    }

    return { canView, canViewReasoning };
  }, [appStore, data?.collectorId]);
  const { canView, canViewReasoning } = calcUserCanView();

  return { canView, canViewReasoning, canEdit, canEditReasoning };
};
